import _ from 'lodash';

$(document).on('ready turbolinks:load', () => {
  const $input = $('input[data-search-offline]');
  const $table = $($input.data('search-offline-target'));
  const childSelectors = $input.data('search-offline-children');
  if (!$table.length) {
    return;
  }

  $input.off('keyup').keyup((e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      return false;
    }

    const filter = $input.val().toLowerCase();
    $table.find('tbody tr').each((index, tr) => {
      const $tr = $(tr);
      if (childSelectors) {
        if (_.some($tr.find(childSelectors),
            child => _(child.innerText).toLower().includes(filter))) {
          $tr.removeClass('hide');
        } else {
          $tr.addClass('hide');
        }
        return;
      }
      if (_(tr.firstElementChild.innerText).toLower().includes(filter)) {
        $tr.removeClass('hide');
      } else {
        $tr.addClass('hide');
      }
    });
    return true;
  });
});
